import React, { useEffect, useState } from "react";

function FormInput({ name, type, changeUserData, inputData, itemLabel, defaultValue}) {
  const [isFilled, setIsFilled] = useState(false);
  const [input, setInput] = useState(defaultValue);

 useEffect(() => {
    if(defaultValue)
    changeUserData(name, defaultValue);
  }, [defaultValue]);

  const changeInputHandler = (e) => {
    setInput(e.target.value);
    changeUserData(name, e.target.value);
  };

  const focusedInputHandler = () => {
    setIsFilled(true);
  };

  useEffect(() => {
    if (input !== " ") {
      setIsFilled(true);
    } else {
      setIsFilled(false);
    }
  }, [input]);

  return (
    <div className="interface-form_group">
       <label
        htmlFor={name}
        className="interface-form_label"
      >{itemLabel ? itemLabel : " "}</label>
      <input
        onFocus={focusedInputHandler}
        className={
          isFilled ? "interface_input active-input" : "interface_input"
        }
        onChange={(e) => changeInputHandler(e)}
        required
        value={input}
        name={name}
        type={type ? type : "text"}
        id={name}
      />
     
   
      
    </div>
  );
}

export default FormInput;
